import { useCallback } from 'react';
import type { IRecord } from '@platform/core/types';
import { baseApi, recordTag } from '@platform/state/api/baseApi';
import { useAppDispatch } from '@platform/state/hooks';

/**
 * Оновлення конверта запису після змін у вкладках (коментар, файл, зв'язок, доручення): лічильники вкладок і пігулок панелі дій
 * беруться з конверта, а мутації співпраці інвалідовують лише власні списки.
 */
export function useRecordRefresh(record: Pick<IRecord, 'id' | 'recordType'>): () => void {
  const dispatch = useAppDispatch();
  return useCallback(() => { dispatch(baseApi.util.invalidateTags([recordTag(record.recordType, record.id)])); }, [dispatch, record.id, record.recordType]);
}
